import request from 'admin-ng/util/request-promise';
import {SERIES} from '.';

export const seriesByName = fragment =>
  request(`${SERIES}?name__contains=${fragment}`, 'get');
